import { useState } from "react";
import FormInput from "../../../../components/Form/FormInput";
import FormSelect from "../../../../components/Form/FormSelect";
import SystemValueForm from "../../../../components/SystemValue/SystemValueForm";
import { TAX_TYPE_OPTIONS } from "./taxFormat";

const validateField = (name, value, type) => {
  if (name === "name" && !value.trim()) return "Name is required.";
  if (name === "type" && !value) return "Type is required.";
  if (name === "value" && type === "percentage") {
    if (value === "") return "Value is required.";
    const n = Number(value);
    if (Number.isNaN(n)) return "Value must be a number.";
    if (n < 0) return "Value cannot be negative.";
    if (type === "percentage" && n > 100) return "A percentage cannot be more than 100.";
  }
  return "";
};

const TaxForm = ({ taxToEdit, onSave, onCancel }) => {
  const [form, setForm] = useState(() => ({
    name: taxToEdit?.name ?? "",
    type: taxToEdit?.type ?? "",
    value: taxToEdit?.value != null ? String(Number(taxToEdit.value)) : "",
  }));
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
      ...(name === "type" && prev.value ? { value: validateField("value", form.value, value) } : {}),
    }));
    setFormError("");
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value, form.type) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = {
      name: validateField("name", form.name, form.type),
      type: validateField("type", form.type, form.type),
      value: validateField("value", form.value, form.type),
    };
    setErrors(next);
    if (Object.values(next).some(Boolean)) return;

    setSubmitting(true);
    const failure = await onSave({
      name: form.name.trim(),
      type: form.type,
      ...(form.type === "percentage" ? { value: Number(form.value) } : {}),
    });
    setSubmitting(false);

    if (failure?.field) setErrors((prev) => ({ ...prev, [failure.field]: failure.message }));
    else if (failure) setFormError(failure.message);
  };

  return (
    <SystemValueForm
      title={taxToEdit ? "Edit Tax" : "Add Tax"}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      error={formError}
      submitting={submitting}
      submitLabel={taxToEdit ? "Update" : "Create"}
    >
      <FormInput
        label="Name"
        name="name"
        value={form.name}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.name}
        placeholder="e.g. GST"
        required
      />
      <FormSelect
        label="Type"
        name="type"
        value={form.type}
        onChange={handleChange}
        onBlur={handleBlur}
        options={TAX_TYPE_OPTIONS}
        error={errors.type}
        required
      />
      {form.type === "percentage" && (
        <FormInput
          label="Value (%)"
          name="value"
          type="number"
          value={form.value}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.value}
          placeholder="e.g. 18"
          required
        />
      )}
      {form.type === "absolute" && (
        <p className="text-xs text-gray-500">
          The amount is set per client, in that client's currency.
        </p>
      )}
    </SystemValueForm>
  );
};

export default TaxForm;